import { AppButton, AppTable } from 'components';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from 'services/api';

const LeagueList = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState([]);
  const [page] = useState(
    searchParams.get('page') ? Number(searchParams.get('page')) : 1
  );
  const titles = ['LİG ADI', 'LİNK', 'SIRA'];

  const onDelete = async id => {
    api.league.delete(id).then(() => {
      navigate(0);
    });
  };

  useEffect(() => {
    api.league
      .list(page)
      .then(async res => {
        setData(res.data);
      })
      .catch(error => console.log('error', error));
  }, []);

  return (
    <main className="w-full">
      <AppButton
        className="mb-5 ml-auto"
        isFullWidth={false}
        onClick={() => navigate('/league/add')}
      >
        Yeni Lig Ekle
      </AppButton>
      <AppTable
        titles={titles}
        rows={data}
        isEdit={true}
        isDelete={true}
        pageKey="league"
        pageNumber={page}
        onDelete={onDelete}
        hideRows="__v,_id,createdDate,desktopCover,mobileCover,nameEn,slugEn,weekNameEn,weekName,logo"
      />
    </main>
  );
};

export default LeagueList;
